import * as React from 'react';

import * as styles from './index.css';

export function getSuggestLinkText(
  text: string | null | undefined,
  query: string,
  alternativeNames?: string[],
  className: string = styles['list-item_text'],
): JSX.Element | null {
  if (!text) {
    return null;
  }
  const lowerQuery = query.toLowerCase();
  const indexOfOccurence = text.toLowerCase().indexOf(lowerQuery);

  if (indexOfOccurence !== -1) {
    return (
      <span className={className}>
        {text.slice(0, indexOfOccurence)}
        <strong>{text.slice(indexOfOccurence, indexOfOccurence + query.length)}</strong>
        {text.slice(indexOfOccurence + query.length)}
      </span>
    );
  }

  if (alternativeNames) {
    const alternativeName = alternativeNames.find(name => name.toLowerCase().includes(lowerQuery));
    if (alternativeName) {
      return getSuggestLinkText(`${text} (${alternativeName})`, query);
    }
  }

  return <span className={className}>{text}</span>;
}
